import axios from "axios";

// Same-origin API calls: the session cookie stays first-party on whatever host
// the user is on (apex, www, or preview), so auth works across all deployed hosts.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function wsUrl() {
  const base = window.location.origin.replace(/^http/, "ws");
  return `${base}/api/ws`;
}

export function fileUrl(fileId) {
  return `/api/files/${fileId}/download`;
}
